import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto flex justify-between items-center p-4">


        <motion.h1
          className="text-2xl font-bold text-blue-600 cursor-pointer"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          whileHover={{
            scale: 1.1,
            color: "#1D4ED8", // Darker blue
            textShadow: "0px 0px 8px rgba(29, 78, 216, 0.5)",
          }}
        >
          Mobi Cashier
        </motion.h1>


        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-6">

          <a href="#features" className="hover:text-blue-500">المميزات</a>
          <a href="#services" className="hover:text-blue-500">الخدمات</a>

          <a href="#home" className="hover:text-blue-500">الرئيسية</a>

        </nav>

        {/* Mobile Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden p-2 text-blue-600 focus:outline-none"
        >
          {/* Icon Hamburger */}
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {/* Mobile Menu with Animation */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="md:hidden bg-white border-t border-gray-200 p-4 space-y-3"
          >
            <a href="#home" className="block hover:text-blue-500" onClick={() => setIsOpen(false)}>Home</a>
            <Link to="/services" className="block hover:text-blue-500" onClick={() => setIsOpen(false)}>Services</Link>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
